module.exports = __webpack_public_path__ + "static/image 99-79b81615c419df0e913ca04820e24bed.png";